<template>
	<div>
		<Affix>
			<div class="header" style="background-color: #fff;">
				<Row type="flex" justify="space-between">
					<Col span="4">
					<span class="navbar-brand" style="padding-left: 10px;">
						<img class="logo" src="../../assets/logo.png" />
					</span>
					</Col>
					<Col span="4" style="text-align: center;padding-top: 4px;">
					<Icon @click="openNews = true" size="30" type="md-menu" />
					</Col>
				</Row>

			</div>
		</Affix>
		<div style="padding: 10px;">
			<img style="width: 100%;border-radius: 10px;" src="../../assets/4.jpg"  />
			<Breadcrumb style="margin:10px 0px;">
				<BreadcrumbItem to="/m/index">首页</BreadcrumbItem>
				<BreadcrumbItem :to="'/m/list?id='+pageId">{{pageWhere}}</BreadcrumbItem>
			</Breadcrumb>
			<div >
				<h2 v-html="data1.title"></h2>
			</div>
			<div>
				<Divider>正文</Divider>
				<p class="newcontent" v-html="data1.body" style="width: 100%;"></p>
			</div>
		</div>
		<div style="width: 100%;height: 300px;background-color: #f6f7f9;padding-top: 20px;">
			<Row type="flex" justify="center" align="middle" >
				<Col span="16">
				2022 &copy; 汇金永信保险销售服务有限公司<br>
				地址：四川省成都市高新区府城大道中段88号中航城市广场1205室<br>
				联系方式：028-85224343
				邮件：hjyxcoltd@163.com<br>
				网站版权所有 hjyxbx.com 所有
				Copyright © 2013 蜀ICP备13002380号  
				</Col>
				<Col span="16" style="text-align: center;">
				<img src="../../assets/erweima.jpg" style="width: 100px;margin-top: 10px;" />
				</Col>
			</Row>
		</div>
		<Drawer :width="200" :closable="false" v-model="openNews">
			<List>
				 	<ListItem >
						<router-link to='/m/index'>
						 首页
						</router-link>
				 	</ListItem>
				 	<ListItem>
						<router-link to='/m/us'>
						 关于汇金
						</router-link>
				 	</ListItem>
				 	<ListItem v-for="(item,index) in titleList" :name="item.id"
				 		v-if="item.id<100">
						<router-link :to='"/m/list?id="+item.id'>
				 		{{item.name}}
						</router-link>
				 	</ListItem>
				 	<ListItem >
						<router-link to='/m/map'>
				 		联系我们
						</router-link>
				 	</ListItem>
			 </List>
		</Drawer> 
		<BackTop></BackTop>
	</div>
</template>
<script>
	import {
		sendMsg
	} from '../../api/index.js'
	import moment from 'moment'
	import striphtml from 'js-striphtml'
	export default {
		data() {
			return {
				showIndex: 0,
				acvtion: "ss_104",
				columns1: [{
						title: '标题',
						key: 'title'
					},
					{
						width: 200,
						title: '创建时间',
						key: 'createTime',
						render: (h, dto) => {
							return h('div', [h('span', moment(dto.row.createTime).format('YYYY-MM-DD hh:mm:ss'))])
						},
						sortType: "desc",
						align: "right"
					}
				],
				data1: [],
				openNews: false,
				showbody: {},
				titleList: [],
				total: 0,
				page: 1,
				typeID: 105,
				pageWhere: "关于汇金",
				pageId:0
			}
		},
		created() {
			this.newsID = this.$route.query.id != undefined && this.$route.query.id != null && this.$route.query.id != '' ?
				this.$route.query.id : 34
			this.initData(this.newsID)	

		},
		mounted() {

		},
		updated() {

		},
		methods: {
			initTiles(id){
				let that = this
				sendMsg("/baseType/list", {}, "POST", false).then(res => {
					this.titleList = res.data.data
					for(var i = 0;i<res.data.data.length;i++){
						console.info(res.data.data[i].id)
						if(res.data.data[i].id == id){
							that.pageWhere = res.data.data[i].name
							this.$forceUpdate()
						}
						
					}
				})
			},
			initData(_id){
				sendMsg("/baseNews/selectById", {
					id:_id
				}, 'POST', false).then(res => {
					this.data1 = res.data.result
					this.initTiles(res.data.result.typeId);
					this.pageId =res.data.result.typeId
				})
			}
		},
		components: {
			sendMsg
		}
	}
</script>

<style scoped>
	.container {
		width: 100%;
		margin-right: auto;
		margin-left: auto;
		max-width: 1140px;
	}

	.header {
		background-color: transparent;
		padding: 0;
		height: 90px;
		display: grid;
		align-items: center;
	}

	.container__wrapper--center {
		margin: 0 auto;
	}

	.navbar {
		width: 100%;
		position: relative;
		display: flex;
		align-items: center;
	}

	.navbar-expand-lg {
		width: 100%;
		min-width: 992px;
		flex-flow: row nowrap;
		justify-content: flex-start;
	}

	.navbar .navbar-brand {
		margin: 2px 0 0;
		padding: 0;
		font-size: 22px;
		color: #fff;
		font-weight: 800;
		text-transform: uppercase;
	}

	a {
		text-decoration: none;

	}


	a:hover {
		background: linear-gradient(#FF6600, #FF6633);
		color: #FFFFFF !important;
	}

	.logo {
		width: auto;
		height: 40px;
	}

	.navbar-nav {
		display: flex;
		flex-direction: row;
		padding-left: 0;
		margin-bottom: 0;
		list-style: none;
		align-items: center;
		margin-left: auto !important;
		height: 80px;
	}

	.navbar-collapse {
		-ms-flex-preferred-size: 100%;
		flex-basis: 100%;
		-ms-flex-positive: 1;
		flex-grow: 1;
		-ms-flex-align: center;
		align-items: center;
	}

	.navbar-expand-lg .navbar-collapse {
		display: -ms-flexbox !important;
		display: flex !important;
		-ms-flex-preferred-size: auto;
		flex-basis: auto;
	}

	.navbar-nav .nav-item {
		padding: 0 18px;
		transition: all .5s ease;
		position: relative;

	}

	.navbar-nav .nav-item :hover::before {
		position: absolute;
		top: 40px;
		right: calc(50% - 10px);
		width: 20px;
		height: 3px;
		background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAAA+CAMAAACRDYw7AAAAQlBMVEUAAAAAAADyhy35vWP4vGP2qk/0mDz4u2H1okj3rlP1pkv0m0D4t1z1n0T3tFn3sVfzlDnzkTbyii/yjjPyjDHyhyxN587IAAAABXRSTlMAArW1tP5J36kAAACnSURBVFjD7dZbCoMwEIXhamuuJtFo9r/VUgMHH2otysAE5l/ARxhye0iSJElSG3W7iGREQyMSG9HQiMRGJDZii3enscT7kvO6LPM8TUop730Ixhjn3DAM1toUYxxHrZ+X8PLB1yM8pVRxfQ3P31ZebTK86pt9Ay/bVICHEGDfxnssHPhuLJjKi99W/AvnevxPcb5X7m+d9zN3qLfwtYAPWZIkSZKa6A0wZw0kr1ugbQAAAABJRU5ErkJggg==) no-repeat 50%;
		content: "";
		border-radius: 4px;
	}

	.navbar-expand-lg .navbar-nav .nav-link {
		padding: 6px 7px;
		font-size: 16px;
		border-bottom: 1px solid transparent;
		opacity: .8;
		color: #000;
		border-radius: 4px;
	}

	.navbar-expand-lg .navbar-nav .active {}
	
	.ytitle {
		width: 100%;
		text-align: center;
		height: 30px;
		margin-bottom: 20px;
		margin-top: 20px;
	}
	
	.ytitle .item {
		width: 20%;
		float: left;
		height: 30px;
		font-size: 16px;
		line-height: 30px;
		cursor: pointer;
	}
	
	.cheak {
		color: #2d8cf0;
	
	}
	
	.cheak::before {
		content: "";
		display: inline-block;
		width: 64px;
		height: 4px;
		position: absolute;
		bottom: 18px;
		background-color: #FF6600;
		margin-right: 6px;
	}
	
	.newsBody p {
		position: relative;
		line-height: 20px;
		max-height: 40px;
		overflow: hidden;
	}
	
	.newsBody p::after {
		content: "...";
		position: absolute;
		bottom: 0;
		right: 0;
		padding-left: 40px;
		background: -webkit-linear-gradient(left, transparent, #fff 55%);
		background: -o-linear-gradient(right, transparent, #fff 55%);
		background: -moz-linear-gradient(right, transparent, #fff 55%);
		background: linear-gradient(to right, transparent, #fff 55%);
	}
	
	.newcontent >>> img {
	    max-width: 100%;
	    height: auto;
	  }
</style>
